import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { LearningResource } from "../models/learningResource";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: "root"
})
export class LearningResourceService {

    mockResources: LearningResource[]

    private createHeader() {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };
        return httpOptions;
    }

    constructor(private httpClient: HttpClient) { }

    getRankedLearningResourcesByUserId(userId: string) : Observable<LearningResource[]> {
        return this.httpClient.get<LearningResource[]>(`${environment.ApiEndpoint}/LearningResource/GetRankedLearningResourceByUserId?userId=` + userId, this.createHeader());
    }
}
